import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { AI_WALKTHROUGH } from "@/config/aiStack";

/** Step-by-step example of an AI assistant project, idea → launch (Services page). */
export function AiWalkthrough() {
  return (
    <section
      id="ai-walkthrough"
      className="py-20 max-w-6xl mx-auto px-6 scroll-mt-28"
      data-testid="ai-walkthrough-section"
    >
      <Reveal className="mb-12 grid grid-cols-1 md:grid-cols-5 gap-8 items-end">
        <div className="md:col-span-3">
          <span className="font-mono-sub text-xs text-royal uppercase tracking-wider font-bold">
            How an AI project runs
          </span>
          <h2 className="font-poster text-3xl md:text-4xl font-bold text-steel mt-2">
            From idea to a working AI assistant in about five weeks
          </h2>
        </div>
        <p
          className="md:col-span-2 rounded-xl border border-line bg-white p-5 text-sm text-ink leading-relaxed shadow-sm"
          data-testid="ai-walkthrough-scenario"
        >
          {AI_WALKTHROUGH.scenario}
        </p>
      </Reveal>

      <ol className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {AI_WALKTHROUGH.steps.map((step, i) => (
          <Reveal key={step.name} delay={(i % 3) * 60}>
            <li
              data-testid={`ai-walkthrough-step-${i + 1}`}
              className="group relative h-full rounded-2xl border border-line bg-white p-6 shadow-sm transition-[border-color,box-shadow] hover:border-royal/40 hover:shadow-md"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-steel font-mono-sub text-sm font-bold text-white">
                  0{i + 1}
                </span>
                <span className="rounded bg-royal-light px-2 py-1 font-mono-sub text-[11px] font-semibold text-royal">
                  {step.duration}
                </span>
              </div>
              <h3 className="font-poster text-lg font-bold text-steel mt-5">{step.name}</h3>
              <p className="text-sm text-ink mt-2 leading-relaxed">{step.text}</p>
              <p className="mt-4 border-t border-line pt-3 font-mono-sub text-[11px] text-royal leading-relaxed">
                You get: {step.deliverable}
              </p>
            </li>
          </Reveal>
        ))}
      </ol>

      <Reveal className="mt-10">
        <Link
          to="/contact"
          data-testid="ai-walkthrough-cta"
          className="inline-flex items-center gap-2 text-sm font-semibold text-royal hover:text-royal-dark transition-colors"
        >
          Have a use case in mind? Request a consultation <ArrowRight className="w-4 h-4" />
        </Link>
      </Reveal>
    </section>
  );
}
